<div class="table-responsive app-table-wrap" [class.has-pagination]="showPagination">
  <table class="table align-middle app-table">
    <thead>
      <tr>
        @for (col of columns; track col.key) {
          <th>{{ col.label }}</th>
        }
        @if (showActions) {
          <th class="text-end">Actions</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of data; track row) {
        <tr>
          @for (col of columns; track col.key) {
            <td>
              @switch (col.type) {
                @case ('icon') {
                  <i [class]="'bi ' + row[col.key]"></i>
                }
                @case ('badge') {
                  <span class="badge-pill" [class]="badgeClass(row[col.key], col)">{{ row[col.key] }}</span>
                }
                @case ('boolean') {
                  <i class="bi" [class.bi-check-circle-fill]="row[col.key]" [class.bi-dash-circle]="!row[col.key]" [class.text-success]="row[col.key]" [class.text-muted]="!row[col.key]"></i>
                }
                @case ('button') {
                  @if (!col.buttonVisibleKey || row[col.buttonVisibleKey]) {
                    <button type="button" class="col-action-btn" (click)="columnAction.emit({ key: col.key, row })">
                      <i class="bi" [class]="col.buttonIcon"></i> {{ col.buttonLabelKey ? row[col.buttonLabelKey] : col.buttonLabel }}
                    </button>
                  } @else {
                    <span class="col-empty">{{ col.emptyPlaceholder ?? '—' }}</span>
                  }
                }
                @default {
                  {{ row[col.key] ?? '-' }}
                }
              }
            </td>
          }
          @if (showActions) {
            <td class="text-end actions-cell">
              @if (actions.includes('edit')) {
                <button type="button" class="icon-btn" (click)="edit.emit(row)">
                  <i class="bi bi-pencil"></i>
                </button>
              }
              @if (actions.includes('changePassword')) {
                <button type="button" class="icon-btn" (click)="changePassword.emit(row)">
                  <i class="bi bi-key"></i>
                </button>
              }
              @if (actions.includes('settings')) {
                <button type="button" class="icon-btn" (click)="settings.emit(row)">
                  <i class="bi bi-gear"></i>
                </button>
              }
              @if (actions.includes('delete')) {
                <button type="button" class="icon-btn text-danger" (click)="delete.emit(row)">
                  <i class="bi bi-trash"></i>
                </button>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>

@if (showPagination) {
  <app-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="totalItems"
    (pageChange)="pageChange.emit($event)"
  />
}
